// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Crx1jPI8AtIjDe {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.QO65nPLWqfbI_2 {
  display: flex;
  justify-content: center;
}
.hLKUtCgC6LiUKV {
  flex: 1 1 auto;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
  background-color: var(--ds-surface, #ffffff);
}
.M1hS5avFgtexqk {
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
@media only screen and (max-width: 600px) {
  .M1hS5avFgtexqk {
    display: block;
    padding-top: 0;
  }
}
@media only screen and (max-width: 860px) {
  .M1hS5avFgtexqk.rosdPSqaSkvJ_i {
    display: block;
    padding-top: 0;
  }
}
.CiHcX34w2qFRYt {
  width: 960px;
}
@media only screen and (max-width: 1242px) {
  .CiHcX34w2qFRYt {
    width: 640px;
  }
}
@media only screen and (max-width: 1007px) {
  .CiHcX34w2qFRYt {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .CiHcX34w2qFRYt.NjLOiw5K5l0_kA {
    display: none;
  }
}
.CiHcX34w2qFRYt.rosdPSqaSkvJ_i {
  width: 960px;
}
@media only screen and (max-width: 1520px) {
  .CiHcX34w2qFRYt.rosdPSqaSkvJ_i {
    width: 640px;
  }
}
@media only screen and (max-width: 1267px) {
  .CiHcX34w2qFRYt.rosdPSqaSkvJ_i {
    width: 100%;
  }
}
.LpSaBztja2ekJx {
  display: flex;
  align-items: center;
  justify-content: center;
}
.x660wFdAAr3LU_ {
  padding: 0 15%;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
@media only screen and (max-width: 1242px) {
  .x660wFdAAr3LU_ {
    padding: 0 10%;
  }
}
.x660wFdAAr3LU_ .QNSFSfGe6B7MTx {
  width: 100%;
  margin: 16px auto;
}
.kYiTMXWFq1MruW {
  margin-top: 16px;
}
.Q0G8GazUurXjEH {
  display: flex;
}
.JHR8RZTJhYmFYJ {
  width: 400px;
  margin: 16px 0;
  padding: 16px;
  border-radius: 4px;
  background: var(--ds-background-warning, #fff7d6);
  color: var(--ds-text-accent-orange-bolder, #5f3811);
  text-align: center;
}
._g0cBLS9YWqqbB {
  flex: 0 0 auto;
  width: 96px;
  height: 96px;
  border-radius: 9px;
  background-repeat: no-repeat;
  background-size: contain;
}
.kL5ufoBfsnIoqe {
  display: flex;
  height: 96px;
  margin: 0 32px;
}
.kL5ufoBfsnIoqe img {
  width: 96px;
  height: 96px;
}
.kjI44BUxo8gxzk {
  width: 400px;
}
.VdWkgdwKVHpEAW button {
  margin-left: 16px;
}
.tv8QBETCrcpO9a {
  width: 160px;
  margin-bottom: 16px;
}
._U03yYTyY6X22s {
  margin-top: 16px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.VdWkgdwKVHpEAW {
  margin-top: 16px;
  text-align: center;
}
.bedZ_VChRKT6K8 {
  padding-top: 32px;
}
.RCc9ce1w70pPKu {
  color: var(--ds-text-accent-green, #216e4e);
  text-align: center;
}
.AacLg_nKdICLYZ {
  color: var(--ds-text-accent-red, #ae2a19);
  text-align: center;
}
.AdRAKoDHARPdRE {
  width: 96px;
}
.HipVlU2nt8V7vA button,
.Rzi6YuQ2uhizle button {
  margin: 0 16px;
}
.HipVlU2nt8V7vA .NfJaJDNgoXx_QD,
.Rzi6YuQ2uhizle .NfJaJDNgoXx_QD {
  text-decoration: none;
}
.Rzi6YuQ2uhizle,
.IUSclV90audPw9,
.FC7paMnhnNYkun,
.HipVlU2nt8V7vA {
  margin-top: 16px;
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `Crx1jPI8AtIjDe`,
	"flexAndCenter": `QO65nPLWqfbI_2`,
	"directoryBody": `hLKUtCgC6LiUKV`,
	"navigationAndContent": `M1hS5avFgtexqk`,
	"workspaceNavigationExpanded": `rosdPSqaSkvJ_i`,
	"directoryContent": `CiHcX34w2qFRYt`,
	"navigationExpanded": `NjLOiw5K5l0_kA`,
	"directorySpinnerContainer": `LpSaBztja2ekJx`,
	"listingWrapper": `x660wFdAAr3LU_`,
	"upgradePromptFullPupPage": `QNSFSfGe6B7MTx`,
	"errorContainer": `kYiTMXWFq1MruW`,
	"enableHeader": `Q0G8GazUurXjEH`,
	"errorAlert": `JHR8RZTJhYmFYJ`,
	"largePowerUpIcon": `_g0cBLS9YWqqbB`,
	"addPowerUpIcon": `kL5ufoBfsnIoqe`,
	"enableBoardSelector": `kjI44BUxo8gxzk`,
	"enableButtonsContainer": `VdWkgdwKVHpEAW`,
	"enableIconContainer": `tv8QBETCrcpO9a`,
	"enableIconSubtitle": `_U03yYTyY6X22s`,
	"successContainer": `bedZ_VChRKT6K8`,
	"successHeading": `RCc9ce1w70pPKu`,
	"errorHeading": `AacLg_nKdICLYZ`,
	"enableButton": `AdRAKoDHARPdRE`,
	"successButtons": `HipVlU2nt8V7vA`,
	"errorButtons": `Rzi6YuQ2uhizle`,
	"buttonLink": `NfJaJDNgoXx_QD`,
	"errorText": `IUSclV90audPw9`,
	"successText": `FC7paMnhnNYkun`
};
export default ___CSS_LOADER_EXPORT___;
